module.exports = __webpack_public_path__ + "img/slika1.221babc3.jpg";